import { useEffect, useState } from 'react';

import { ACCESS_TOKEN, REFRESH_TOKEN } from '../service/constants';

export const USER_INFO = 'user-info';
const LOGIN_CONGIF = 'login-config';
const PUBLIC_STORAGE_KEYS = ['lang', LOGIN_CONGIF, 'platform_config'];

export function getLoginConfigInfo() {
  return JSON.parse(localStorage.getItem(LOGIN_CONGIF));
}

export function setLoginConfigInfo(data) {
  data && localStorage.setItem(LOGIN_CONGIF, JSON.stringify(data));
}

export function getUserInfo() {
  return JSON.parse(localStorage.getItem(USER_INFO));
}

export function setUserInfo(data) {
  data && localStorage.setItem(USER_INFO, JSON.stringify(data));
}

export function removeUserInfo() {
  localStorage.removeItem(USER_INFO);
}

export const getStorage = (key: string) => {
  return localStorage.getItem(key);
};

export const removeStorage = (key: string) => {
  localStorage.removeItem(key);
};

export const setStorage = (key: string, value: string) => {
  localStorage.setItem(key, value);
};

export function getAccessToken() {
  return getStorage(ACCESS_TOKEN);
}

export function setAccessToken(data) {
  data && localStorage.setItem(ACCESS_TOKEN, data);
}

export function removeAccessToken() {
  localStorage.removeItem(ACCESS_TOKEN);
}

export function getRefeshToken() {
  return getStorage(REFRESH_TOKEN);
}

export function setRefeshToken(data) {
  data && localStorage.setItem(REFRESH_TOKEN, data);
}

export function removeRefeshToken() {
  localStorage.removeItem(REFRESH_TOKEN);
}

export function clearStorage() {
  localStorage.clear();
}

export function clearTokens() {
  localStorage.removeItem(REFRESH_TOKEN);
  localStorage.removeItem(ACCESS_TOKEN);
  localStorage.removeItem(USER_INFO);
}

/** 清理用户会话及业务缓存，同时保留语言和公开平台配置。 */
export function clearUserSessionStorage() {
  const publicStorage = PUBLIC_STORAGE_KEYS.map((key) => [key, localStorage.getItem(key)] as const);
  localStorage.clear();
  publicStorage.forEach(([key, value]) => value !== null && localStorage.setItem(key, value));
}

/**
 * 增删改查LocalStorage的hooks
 */
function useStorage(key: string, defaultValue?: string): [string, (string) => void] {
  const [storedValue, setStoredValue] = useState(getStorage(key) || defaultValue);

  const setStorageValue = (value: string) => {
    setStorage(key, value);
    if (value !== storedValue) {
      setStoredValue(value);
    }
  };

  useEffect(() => {
    const storageValue = getStorage(key);
    if (storageValue) {
      setStoredValue(storageValue);
    }
  }, [key]);
  return [storedValue, setStorageValue];
}

export function _getStorage(k, defaultValue: any = undefined) {
  try {
    return JSON.parse(localStorage.getItem(k)) || defaultValue;
  } catch (error) {
    return localStorage.getItem(k) || defaultValue;
  }
}

export function _setStorage(k, v) {
  try {
    if (v === null) {
      localStorage.removeItem(k);
    } else {
      localStorage.setItem(k, JSON.stringify(v));
    }
  } catch (error) {
    if (typeof window !== 'undefined') {
      console.error(error);
    }
  }
}

export default useStorage;
